import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { connect } from 'react-redux';

import { submitContact } from '../../actions/index';
import _data from '../../data';
import { db } from './../../config/firebaseConfig';

class Contact extends Component {

  recaptchaRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phone: "",
      motive: "",
      message: "",
      disableContactBtn: false,
      contactBtnText: "Enviar Mensaje",
      contact: {},
      validationErrorMessage: "",
      successSubmitted: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  /**
   * When we click on Send button, changeBtnText function will help to change text
   * @param contactBtnText
   */
  changeBtnText = contactBtnText => {
    this.setState({ contactBtnText });
  };

  /**
   * Get all form data and set to the state
   * @param contactBtnText
   */
  handleFormValueChange(inputName, event) {
    let stateValue = {};
    stateValue[inputName] =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState(stateValue);
  }

  formValidations(name,email,phone,motive,message){

    const initialNumber = phone.charAt(0);
    const threeFirstsNumber = phone.substr(0,3);
    const nineRemainNumbers = phone.substr(3);
    const recaptchaValue = this.recaptchaRef.current; 
    if(name === "" || email === "" || phone === "" || motive === "" || message === ""){
      this.setState({ validationErrorMessage: "Error: Todos los campos son obligatorios" });
      return false
    };
    if(!recaptchaValue.getValue()){
      this.setState({ validationErrorMessage: "Error: verifica que no eres un robot" });
      return false
    }
    if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))){
      this.setState({ validationErrorMessage: "Error: Debe ingresar un email válido" });
      return false
    }
    if(isNaN(phone)){
      this.setState({ validationErrorMessage: "Error: Se debe digitar un numero válido" });
      return false
    }
    if (initialNumber === '0' && !(phone.length === 10)){
      this.setState({ validationErrorMessage: "Error: El número telefónico debe tener 10 dígitos" });
      return false;
    }else if(threeFirstsNumber === '593' && !(nineRemainNumbers.length === 9)){
      this.setState({ validationErrorMessage: "Error: El número telefónico debe tener 9 dígitos apartir del 593" });
      return false;
    }
    recaptchaValue.reset();
    this.setState({ validationErrorMessage: "" });
    return true;
  }

  saveContact = async () =>{
    await db.collection('contact-form').doc().set({
      name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      motive: this.state.motive,
      message: this.state.message,
    })
  }

  /**
   * Submit the form and dispatch to the store
   * @param contactBtnText
   */
  handleSubmit(event) {
    event.preventDefault();

    let name = this.state.name;
    let email = this.state.email;
    let phone = this.state.phone;
    let motive = this.state.motive;
    let message = this.state.message;

    if (!this.formValidations(name,email,phone,motive,message)) return;

    this.changeBtnText("Enviando...");
    // disable the button
    this.setState({ disableContactBtn: true });

    // get action
    const contactAction = submitContact(this.state);

    // Dispatch the contact from data
    this.props.dispatch(contactAction);

    // added delay to change button text to previous
    setTimeout(
      function() {
        // enable the button
        this.setState({ disableContactBtn: false });

        // change to button name
        this.changeBtnText("Enviar Mensaje");

        // get action again to update state
        const contactAction = submitContact(this.state);

        // Dispatch the contact from data
        this.props.dispatch(contactAction);

        this.saveContact();

        this.setState({ successSubmitted : true });

        setTimeout( () =>{
          this.setState({ successSubmitted : false});
        },3000)

        // clear form data
        this.setState({
          name: "",
          email: "",
          phone: "",
          motive: "",
          message: ""
        });
      }.bind(this),
      3000
    );
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
    this.setState({
      contact: _data.contact
    });
  }

  render() {
    return (
      <React.Fragment>
        <section id="contact" className={"contact-us ptb-100 " + (this.props.bgColor && this.props.bgColor === 'white' ? '' : 'gray-light-bg')}>
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <div className="section-heading">
                  <h3>{this.state.contact.title}</h3>
                  <p>{this.state.contact.description}</p>
                </div>
                <div className="footer-address">
                  <h6>
                    <strong>{this.state.contact.office}</strong>
                  </h6>
                  <p>{this.state.contact.address}</p>
                  <ul>
                    <li>
                      <span>Phone: {this.state.contact.phone}</span>
                    </li>
                    <li>
                      <span>
                        Email :{" "}
                        <a href="mailto:contacto@frisbee.com.ec">
                          {this.state.contact.email}
                        </a>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-7">
                <form
                  method="POST"
                  id="contactForm1"
                  className="contact-us-form"
                  onSubmit={this.handleSubmit}
                >
                  <h5>Déjanos tu mensaje</h5>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.name}
                          onChange={e => this.handleFormValueChange("name", e)}
                          type="text"
                          className="form-control"
                          name="name"
                          placeholder="Nombre y Apellido"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.email}
                          onChange={e => this.handleFormValueChange("email", e)}
                          type="text"
                          className="form-control"
                          name="email"
                          placeholder="E-mail"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.phone}
                          onChange={e => this.handleFormValueChange("phone", e)}
                          type="number"
                          name="phone"
                          className="form-control"
                          id="phone"
                          placeholder="Teléfono / WhatsApp"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          value={this.state.motive}
                          onChange={e =>
                            this.handleFormValueChange("motive", e)
                          }
                          type="text"
                          name="motive"
                          size="40"
                          className="form-control"
                          id="motive"
                          placeholder="Motivo"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <textarea
                          onChange={e =>
                            this.handleFormValueChange("message", e)
                          }
                          value={this.state.message}
                          name="message"
                          id="message"
                          className="form-control"
                          rows="7"
                          cols="25"
                          placeholder="Mensaje"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col mt-2">
                      <button
                        type="submit"
                        className="btn solid-btn"
                        id="btnContactUs"
                        disabled={this.state.disableContactBtn}
                      >
                        {this.state.contactBtnText}
                      </button>
                    </div>
                    <div className="col mt-1 d-flex justify-content-center">
                    <ReCAPTCHA
                      ref={this.recaptchaRef}
                      size={'compact'}
                      sitekey={ 
                        process.env.NODE_ENV === "development" ? 
                        process.env.REACT_APP_SITE_KEY_LOCAL_RECAPTCHA :
                        process.env.REACT_APP_SITE_KEY_PROD_RECAPTCHA
                      }
                      onChange={this.onChange}
                    />
                    </div>
                  </div>
                </form>
                <p className="form-message">{this.state.validationErrorMessage}</p>
                { this.state.successSubmitted ? <span class="badge badge-pill badge-success ml-2">Enviado!</span> : null}
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  state
}))(Contact);
